import React, { useState } from 'react'
import { Checkbox } from "antd"

import Modal from "../reusable/modal"

import { usePet, useToggle } from '../../modules'
import pluralize from 'pluralize'

const Returns = ({ toggle, visible, record, store, onPerform }) => {
    const [returnedBy, setReturnedBy] = useState()
    const [bulk, setBulk] = useState()
    const [contains, setContains] = useState()

    const [singles, toggleSingles] = useToggle()

    const modify = e => {
        switch (e.target.name) {
            case 'bulk':
                setBulk(e.target.value)
                break
                
            case 'contains':
                setContains(e.target.value)
                break

            case 'returnedBy':
                setReturnedBy(e.target.value)
                break

            default:
                break
        }
    }

    const onComplete = ({}, notif, ops) => {
        onPerform()
        notif('Returns has been recorded', ops('success'))
        
        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('recordReturns', {
        returnedBy,
        items: [
            {
                item: record?.item?._id,
                store: store?.value ?? store?._id,
                bulkCount: bulk,
                containing: contains
            }
        ],
        committed: true
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Recording Returns...' } })

    return (
        <Modal
            w={ 400 }
            title="Record Returns"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap mt-3">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Returned By
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-bulk"
                        name="returnedBy"
                        value={ returnedBy }
                        onChange={ modify }
                        type="text"
                        placeholder="Wilson Kamau" />
                </div>
            </div>
            <Checkbox checked={ singles } onChange={ () => {
                setBulk(1)
                toggleSingles()
            } }>Items were returned in { record?.item?.issuedIn?.toLowerCase() }</Checkbox>
            {
                !singles &&
                <div className="flex flex-wrap mt-3">
                    <div className="w-full px-3 mb-6 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            How many { record?.item?.receivedIn}?
                        </label>
                        <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="grid-bulk"
                            name="bulk"
                            value={ bulk }
                            onChange={ modify }
                            type="number"
                            placeholder="50" />
                    </div>
                </div>
            }
            <div className="flex flex-wrap mt-3 mb-6">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        How many { record?.item?.issuedIn}?
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-contains"
                        type="number"
                        name="contains"
                        value={ contains }
                        onChange={ modify }
                        placeholder="100" />
                    <p className="text-gray-500 text-xs italic">How many { record?.item?.issuedIn?.toLowerCase()} { singles ? 'were received' : `does each ${ record?.item?.receivedIn && pluralize.singular(record?.item?.receivedIn?.toLowerCase()) } contain` }?</p>
                </div>
            </div>
            <div className="flex justify-end">
                <button disabled={ loading } onClick={ execute } className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Record Returns</button>
            </div>
        </Modal>
    )
}

export default Returns